import pipe from "../lib/core/functional/pipe";
import htmlDecode from "../utils/htmlDecode";
import evaluateLoadedScripts from "../utils/pageScripts";

function hideFbPreview(container) {
    const videoPreview = container.querySelector(".widget__image");
    videoPreview.style.display = "none";
    return container;
}

function showFbVideo(container) {
    const videoWidget = container.querySelector(".widget__video");
    const markup = videoWidget.querySelector('script[type="video-content"]');
    if (markup) {
        videoWidget.innerHTML = markup.innerHTML;
        videoWidget.style.display = "block";
    }
    return container;
}

function togglePreview(container) {
    const playButton = container.querySelector(".widget__play");
    if (playButton) {
        playButton.classList.toggle("rm-zindex-hidden");
    }

    const lazyLoader = container.querySelector(".lazyload-placeholder");
    if (lazyLoader) {
        playButton.classList.toggle("rm-zindex-hidden");
    }

    return container;
}

function showVideo(container) {
    const videoTemplate = container.querySelector("template");

    const contentContainer = document.createElement("div");
    contentContainer.classList.add("rm-video-holder");

    if ("content" in videoTemplate) {
        const content = videoTemplate.content.cloneNode(true);
        contentContainer.appendChild(content);
    } else {
        contentContainer.innerHTML = htmlDecode(videoTemplate.innerHTML);
    }

    container.appendChild(contentContainer);
    evaluateLoadedScripts(contentContainer);

    return container;
}

function playVideo(container) {
    container.classList.add("rm-playing");

    let videoNode = container.querySelector("video");
    if (videoNode) {
        videoNode.play();
    }

    return container;
}

function hideVideo(container) {
    const videoHolder = container.querySelector(".rm-video-holder");

    if (videoHolder) {
        videoHolder.remove();
    }

    return container;
}

function stopVideo(container) {
    container.classList.remove("rm-playing");
    return container;
}

const videoLifecycle = pipe(togglePreview, showVideo, playVideo);
const stopVideoLifecycle = pipe(togglePreview, hideVideo, stopVideo);

const fbVideoLifecycle = pipe(hideFbPreview, showFbVideo, playVideo);

function renderVideoPlayer(event) {
    const { currentTarget } = event;
    const modernContainer = currentTarget.closest(".rm-widget-image-holder");
    if (modernContainer) {
        if (modernContainer.classList.contains("rm-playing")) {
            stopVideoLifecycle(modernContainer);
        } else {
            videoLifecycle(modernContainer);
        }
    } else {
        const container = currentTarget.closest(".widget__head");
        fbVideoLifecycle(container);
    }
}

export default function videoPlayer(_context, videoElement) {
    videoElement.addEventListener("click", renderVideoPlayer);
}
